export const transformStatsData = (apiData) => [
    {
        title: "Total companies",
        value: apiData.totalCompanies?.toString() || "0"
    },
    {
        title: "Ongoing MRR",
        value: apiData.ongoingMrr ? `$${apiData.ongoingMrr.toFixed(2)}` : "$0.00"
    },
    {
        title: "Total MRR",
        value: apiData.totalMrr ? `$${(apiData.totalMrr / 1000).toFixed(2)}K` : "$0.00"
    }
];

export const transformStageDistributionData = (stageDistribution) => {
    const colors = {
        demo                                 : "#fca5a5",
        onboarding_not_active                : "#fdba74",
        trial                                : "#d8b4fe",
        onboarding_extended_more_than_30_days: "#bef264",
        onboarding_won                       : "#93c5fd",
        onboarding_invoice_raised            : "#f472b6",
        onboarding_redirect_to_sdr           : "#4ECDC4",
        onboarding_pause                     : "#3b82f6",
        onboarding_ongoing                   : "#96CEB4",
        account_management                   : "#818cf8",
        onboarding_roll_over_the_next_quarter: "#FF9FF3"
    };

    const totalCount = Object.values(stageDistribution).reduce(
        (sum, val) => sum + val,
        0
    );

    const data = Object.entries(stageDistribution)
        .map(([key, count]) => {
            if (!count) return null;
            const stage = key
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase());
            return {
                name : stage,
                y    : count,
                perc : Math.round((count / totalCount) * 100),
                color: colors[key] || "#1677FF"
            };
        })
        .filter(Boolean);

    return {
        series: [{ name: "Companies", data, colorByPoint: true }]
    };
};

const formatDateLabel = (dateStr) => new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day  : "numeric"
});

const buildGraphSeries = ({ data, name, color }) => ({
    name,
    color,
    fillOpacity: 0.3,
    data       : data.map((item) => ({
        y    : item.count || 0,
        value: item.value || 0,
        count: item.count || 0,
        date : item.date
    }))
});

export const transformOnboardingWonData = (data) => ({
    categories: data.map((d) => d.date),
    series    : [buildGraphSeries({ data, name: "Onboarding Won", color: "#93c5fd" })]
});

export const transformMrrGraphData = (data) => ({
    categories: data.map((d) => formatDateLabel(d.date)),
    series    : [buildGraphSeries({ data, name: "MRR", color: "#a855f7" })]
});

export const transformUpsellOverPeriodData = (data) => ({
    categories: data.map((d) => formatDateLabel(d.date)),
    series    : [buildGraphSeries({ data, name: "Upsell Count", color: "#fdba74" })]
});

export const transformChurnOverPeriodData = (data) => ({
    categories: data.map((d) => formatDateLabel(d.date)),
    series    : [buildGraphSeries({ data, name: "Churn Count", color: "#4ECDC4" })]
});

export const formatTooltip = ({ date, count, value, label }) => {
    return `
        <b>${date}</b><br/>
        ${label} Count: <b>${count}</b><br/>
        ${label} Value: <b>$${(value / 1000).toFixed(2)}K</b>
    `;
};
